import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

import SignedOutPromoPanel from './SignedOutPromoPanel';
import SignInFormNew from '../common/SignInFormNew';
import SignedOutFooter from './SignedOutFooter';

const Globals = require('../../../../app/globals');
const UriUtil = require('../../util/UriUtil');
const Strings = require('../../../../app/shared/Strings');

const propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }).isRequired,
};

const defaultProps = {};

function SignIn(props) {
    const query = UriUtil.parseLocationSearchString(props.location);
    const redirectToPath = query[Globals.uri.query.REDIRECT_TO_PATH];
    const signUpParams = !!redirectToPath ? `?${Globals.uri.query.REDIRECT_TO_PATH}=${encodeURIComponent(redirectToPath)}` : '';
    const gotoDemo = () => {
        window.location = "https://www.muzzylane.com/demo";
    }

    return (
        <div className="fill signed-out--new">
            <div className="container rel-centered-v">
                <div className="signedOutDual">
                    <SignedOutPromoPanel />
                    <div className="signedOutDual__form">
                        <div className="signedOutDual__formHeaderArea">
                            <h2 className="signedOutDual__formHeaderArea--header">
                                {Strings['en'].signed_out.sign_in_new.form.SIGN_IN}
                            </h2>
                            <div className="signedOutDual__formHeaderArea--subtitle">
                                {Strings['en'].signed_out.sign_in_new.form.WELCOME}
                            </div>
                        </div>
                        <SignInFormNew forwardTo={redirectToPath} />
                        <div className="signedOutDual__buttonRow margin-top-lg">
                            <Button
                                variant="secondary"
                                onClick={gotoDemo}
                            >
                                {Strings['en'].signed_out.sign_in_new.form.NEW_USER}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <SignedOutFooter />
        </div>
    );
}

SignIn.propTypes = propTypes;
SignIn.defaultProps = defaultProps;

export default withRouter(SignIn);